export default __webpack_public_path__ + "static/media/mail_inactive.81efd54e.png";